import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const CostoTransporteVentasBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getTransportCost, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getTransportCost() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Servicios Logísticos', 'Alimentos', 'Construcción', 'Sector salud/ Farmacéuticas', 'Retail', 'Manufactura', 'Automotriz'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [19, 5, 5, 4, 3, 4, 7];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [13, 9, 11, 8, 4, 3, 2];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [6, 10, 11, 3, 7, 7, 6];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 9,
        },
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : context.datasetIndex === 1 ? 12 : 22;
        },
        formatter: (value) => `${value}%`,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 25,
        ticks: {
          stepSize: 5,
        },
      },
    },
  };

  const infoContent = {
    formula: '% transporte tercerizado = [(Costo almacenamiento + Embalaje + Costo de transporte) / Ventas netas] x 100',
    description: 'Muestra todos los costos relacionados con la distribución, desde el almacén hasta el cliente.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CostoTransporteVentasBar;
